function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".undraw_vehicle_sale_svg__a,.undraw_vehicle_sale_svg__i,.undraw_vehicle_sale_svg__q{fill:#4091f7}.undraw_vehicle_sale_svg__a,.undraw_vehicle_sale_svg__e,.undraw_vehicle_sale_svg__h{opacity:.1}.undraw_vehicle_sale_svg__c{fill:#65617d}.undraw_vehicle_sale_svg__d{fill:#dce0ed}.undraw_vehicle_sale_svg__f{fill:#f0f0f4}.undraw_vehicle_sale_svg__g{fill:#636780}.undraw_vehicle_sale_svg__h,.undraw_vehicle_sale_svg__l{fill:#fff}.undraw_vehicle_sale_svg__j{opacity:.15}.undraw_vehicle_sale_svg__k{fill:none;stroke:#000;stroke-miterlimit:10}.undraw_vehicle_sale_svg__m{fill:#a8a8a8}.undraw_vehicle_sale_svg__n{opacity:.2}.undraw_vehicle_sale_svg__p{fill:#33323d}.undraw_vehicle_sale_svg__q{opacity:.3}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .017)"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__a",
  cx: 233.641,
  cy: 72.894,
  rx: 233.641,
  ry: 72.894,
  transform: "translate(0 103.174)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(56.551 -.017)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M113.243 14.848c3.96 5.554 7 21.732 7.848 26.607l7.081-.147c-.369-4.195-8.6-21.221-10.906-25.893a96.671 96.671 0 00-4.023-.567z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M24.794 15.651l.083-4.416 3.138.059-.084 4.416z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M24.884 11.236l-.025 1.435a2.3 2.3 0 00.68.1l2.454.025.029-1.506z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M29.552.062L26.591.007a3.561 3.561 0 00-3.356 2.156 10.07 10.07 0 00.159 8.922 2.458 2.458 0 002.127 1.258l3.775.038z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__f",
  cx: 6.17,
  cy: 3.171,
  rx: 6.17,
  ry: 3.171,
  transform: "rotate(-88.92 19.359 -7.152)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M52.66 15.679l.073-3.866 3.137.059-.073 3.866z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M52.736 11.811l-.021 1.229a2.3 2.3 0 00.68.1l2.454.029.025-1.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M57.409.641L54.448.586a3.553 3.553 0 00-3.331 2.156 10.036 10.036 0 00.159 8.918 2.445 2.445 0 002.122 1.279l3.775.038z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__f",
  cx: 6.17,
  cy: 3.171,
  rx: 6.17,
  ry: 3.171,
  transform: "rotate(-88.92 33.582 -21.057)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M56.578 2.88s1.166.21.529 1.741a10.732 10.732 0 00-.747 2.328s-1.183.587-1.1-1.426a3 3 0 011.318-2.643z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 20.285,
  cy: 18.507,
  rx: 20.285,
  ry: 18.507,
  transform: "rotate(-88.92 135.1 -22.312)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M167.182 74.114c9.673.839 17.2 9.79 16.971 20.554-.164 8.687-5.285 16-12.345 18.758-9.673-.839-17.173-9.79-16.971-20.554.164-8.687 5.29-16.002 12.345-18.758z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 19.585,
  cy: 15.021,
  rx: 19.585,
  ry: 15.021,
  transform: "rotate(-88.92 40.565 25.417)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M34.33 27.52c6.183 2.517 10.591 10.1 10.424 18.993-.18 9.505-5.524 17.328-12.445 18.976-6.183-2.517-10.591-10.1-10.419-18.993.174-9.505 5.518-17.328 12.44-18.976z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M86.272 43.087l-.143-7.131s1.451-3.041 2.848-3.293 4.614-.365 4.614-.365 2.315 10.256.583 13.293-7.902-2.504-7.902-2.504z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M86.272 43.087l-.143-7.131s1.451-3.041 2.848-3.293 4.614-.365 4.614-.365 2.315 10.256.583 13.293-7.902-2.504-7.902-2.504z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M112.002 42.805s1.049-9.841-4.362-10.122c-.7-.034-1.393-.063-2.1-.147-3.746-.419-13.968-1.418-12.789.948 0 0 2.278 8.616.566 10.747zM34.892 59.63l-7.269.071s-1-13.423-1.4-14.455-.516-6.074.839-6.783a34.211 34.211 0 015.935-1.506l3.2 7.693.13 6.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M34.892 59.63l-7.269.071s-1-13.423-1.4-14.455-.516-6.074.839-6.783a34.211 34.211 0 015.935-1.506l3.2 7.693.13 6.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M52.874 37.751l.063-1.489a.868.868 0 00-.881-.9c-3.6.084-16.72.466-19.035 1.594 0 0 2.156 18.7-.7 23.1l.659 14.966 32.135-1.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M55.827 14.232c-.889-.1-1.946-.218-3.129-.336l-.034 1.783 3.138.063zM24.799 15.431v.227l3.138.059.025-1.359a13.422 13.422 0 00-3.163 1.073z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M8.226 59.596l4.74.159 10.13-17.608 1.69-2.941-1.112-7.55-1 1.8zM51.502 38.526l1.9 2.961 5.982-7.777 2.735-3.561-1.56-2.19-1.257 1.461z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M59.296 29.424c0 .151-.021.306-.034.461l.117 3.826 2.735-3.561-1.56-2.19zM22.677 33.46l.419 8.687 1.691-2.941-1.112-7.55z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M64.74 35.078s2.672-17.433-5.8-20.21a1.838 1.838 0 00-.336-.071c-1.955-.277-20.189-2.727-29.727-.419 0 0-6.5.839-6.5 4.337l2.055 42.634 4.669.088-1-28.184s-2-12.307 1.711-13.07 20.554-1.846 26.426-.059c0 0 4.341-.893 3.444 9.753l.168 5.721z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M50.412 40.002a2.689 2.689 0 011.141-2.383c1.326-.969 5.39-3.037 5.39-3.037l1.3.13 3.737 9.794-.65 20.642-7.206 8.586z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M50.412 40.002a2.689 2.689 0 011.141-2.383c1.326-.969 5.39-3.037 5.39-3.037l1.3.13 3.737 9.794-.65 20.642-7.206 8.586z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M78.172 62.176l.26-21.191s.784-8.209-4.128-8.444c0 0-11.59-.134-16.653 1.405a1.124 1.124 0 00-.663 1.615c.969 1.762 2.571 6.409 3.163 18.272l-.239 12.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M53.474 75.25l21.091-.092h.021l10.369-.046-.944-13.872-5.751.1-18.372 3.729-5.759 8.674z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M53.474 75.25l21.091-.092h.021l10.369-.046-.944-13.872-5.751.1-18.372 3.729-5.759 8.674z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M53.474 75.25l21.091-.092.524-9.279-15.2-.81-5.759 8.674z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__h",
  d: "M74.585 75.158l10.37-.046-.944-13.872s-3.356 5.113-8.922 4.639z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M.009 84.957c.344 3.981 3.18 3.406 3.18 3.406l.529-.038 5.231-.373-.092-6.174a22.742 22.742 0 00-5.306.218c-1.969.369-3.693 1.195-3.542 2.961z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M.009 84.957c.344 3.981 3.18 3.406 3.18 3.406l.529-.038a5.373 5.373 0 00.889-2.966 5.034 5.034 0 00-1.057-3.356c-1.968.362-3.692 1.191-3.541 2.954z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__g",
  d: "M72.903 45.934c-.122 6.447 3.649 11.745 8.419 11.837s8.742-5.063 8.863-11.51-3.649-11.745-8.419-11.837-8.741 5.063-8.863 11.51zm3.259.839c.088-4.677 3.108-8.414 6.745-8.343s6.514 3.914 6.426 8.591-3.108 8.389-6.745 8.343-6.514-3.922-6.426-8.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__g",
  d: "M81.058 49.68l-4.115 3.9-1.4-3.582 5.919-3.305z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__i",
  d: "M75.842 10.25l-3.528.365-1.334 1.527 1.808 8.943 3.935 14.43 2.576 9.9 1.829 6.019 1.086 7.936 1.133 5.47 3.641 3.779 7.714-8.763 1.3-2.949 3.083-6-7.6-3.733-8.4-.9-3.767-10.218-2.996-11.813z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M146.229 54.047l3.867 38.7-57.865-3.532 7.047-18.83 11.288-7.039-25.512-.063.059-10.6 10.357-2.034 20.8-1.279 15.621-.4 14.824 5.159"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M146.229 54.047l3.867 38.7-57.865-3.532 7.047-18.83 11.288-7.039-25.512-.063.059-10.6 10.357-2.034 20.8-1.279 15.621-.4 14.824 5.159"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__g",
  d: "M66.381 91.031c-.18 9.593 2.844 18.389 11.707 17.617 11.158-.029 12.164-7.55 12.357-17.148s-5.067-16.833-11.716-16.959-12.164 6.897-12.348 16.49z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M66.314 91.047c.138-7.429 3.482-13.326 8.066-15.549 5.814 1.221 10.168 8.012 10 16.779-.147 7.861-.86 14.333-7.257 16.426-8.171.125-10.986-8.39-10.809-17.656z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__i",
  d: "M55.298 75.757l3.331 3.96-6.1-1.166-4.5-4.291-3.93-8.242-5.684-3.633-14.14 1.648-13.058.252-4.74-4.371 5.39-.629 5.445-.021 13.674-.05 16.275-.126 3.171 8.968 2.42 6.17z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M8.197 90.758c.273.419 9.375 1.992 9.375 1.992l25.138 5.076 43.356 1.447 5.168-4.228 2.664.529.109.021 35.566 7.009.583-.071 9.753-1.2 50.948-6.292-.419-7.387-.252-4.358-.529-9.052-.445-2.378-4.513-.5-2.1-.235-32.919-3.649-4.346-.453-2.412-.268-23.49-3.649-34.371.185.059-10.6-12.804-42.082c-3.008.419-2.974 2.454-2.974 2.454l10.822 39.589-.315 24.186c-24.107 1.976-24.782-3.28-28.624-1.586l-4.32-14.79-40.424-.554c-1.64 1.922 1.716 30.844 1.716 30.844z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M108.897 70.703L95.554 97.989l-4.35 1.309-.961-4.48 5.1-15.172 5.117-8.754z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__j",
  d: "M108.897 70.703L95.554 97.989l-4.35 1.309-.961-4.48 5.1-15.172 5.117-8.754z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 26.346,
  cy: 23.226,
  rx: 26.346,
  ry: 23.226,
  transform: "rotate(-88.854 111.468 16.08)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M108.852 76.32c12.139 1.074 21.548 12.7 21.284 26.7-.214 11.284-6.648 20.793-15.52 24.379-12.135-1.078-21.548-12.706-21.284-26.7.222-11.288 6.661-20.793 15.52-24.379z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M179.791 56.287l1.044 5.453 3.2 16.669 15.155-1.179s.956-2.768-1.393-3.859c0 0-.6-9.45-3.356-12.475a2.793 2.793 0 00-1.082-.784z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__h",
  d: "M180.835 61.724l3.2 16.669 15.155-1.179s.956-2.768-1.393-3.859c0 0-.6-9.451-3.356-12.475z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M145.684 57.104c-2.013 3.238 2.152 33.507 2.152 33.507l37.265-5.453-.839-26.426c-.68-4.753-3.452-5.365-3.452-5.365-12.978-6.867-43.058-8.809-43.058-8.809-27.479.524-52.651 8.138-52.651 8.138 31.325-4.233 60.583 4.408 60.583 4.408z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M147.836 90.611l37.265-5.453-.839-26.426c-.68-4.752-3.452-5.365-3.452-5.365s-27.064-3.091-35.138 3.729c-2.001 3.246 2.164 33.515 2.164 33.515z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M151.796 88.941l31.166-4.648-.68-22.555c-.566-4.056-2.886-4.576-2.886-4.576s-22.626-2.63-29.383 3.192c-1.691 2.765 1.783 28.587 1.783 28.587z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__e",
  cx: 7.735,
  cy: 4.253,
  rx: 7.735,
  ry: 4.253,
  transform: "rotate(-88.92 114.944 -37.529)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__d",
  cx: 7.735,
  cy: 4.253,
  rx: 7.735,
  ry: 4.253,
  transform: "rotate(-88.92 114.837 -37.634)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__f",
  d: "M154.258 64.508s1.737.31.789 2.6a15.694 15.694 0 00-1.112 3.465s-1.762.872-1.636-2.122 1.959-3.943 1.959-3.943z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__e",
  cx: 7.232,
  cy: 3.972,
  rx: 7.232,
  ry: 3.972,
  transform: "rotate(-88.92 124.912 -50.883)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__d",
  cx: 7.232,
  cy: 3.972,
  rx: 7.232,
  ry: 3.972,
  transform: "rotate(-88.92 124.81 -50.992)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__f",
  d: "M177.09 61.882s1.741.31.789 2.592a16 16 0 00-1.112 3.465s-1.758.872-1.632-2.122 1.955-3.935 1.955-3.935z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M159.707 63.992c.222 2.865 1.216 24.073 1.216 24.073l2.374-.348 1.317-.193 1.758-.26.214-.034 6.921-1.019-.94-22.5a2.827 2.827 0 00-2.794-2.7h-.21c-.478.034-.994.071-1.531.122l-.688.067a49.73 49.73 0 00-2.022.247c-.344.05-.684.1-1.015.164-.566.1-1.112.218-1.615.348-.344.088-.671.185-.969.289-1.253.44-2.072 1.002-2.016 1.744z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M169.774 61.014l.872 25.306.768-.055-.864-25.113a2.8 2.8 0 00-.776-.138zM167.345 61.211l.784 25.528 1.183.021-1.279-25.608zM164.308 61.622l1.51 25.633h.768v-.038l-1.259-25.771c-.349.063-.688.126-1.019.176zM161.725 62.259l1.573 25.457v.046l1.33-.113v-.126l-1.934-25.532a6.924 6.924 0 00-.969.268z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M189.698 82.477s2.81-13.175-3.029-13.968-25.1.26-24.631 5.7.944 13.716.944 13.716l3.989-.814s-2.743-12.5 1.917-12.878 16.078-1.472 16.078-1.472 3.1-.466 1.112 10.424z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M189.673 83.732s2.823-14.014-3.016-14.8-25.1.256-24.631 5.7.944 13.716.944 13.716l3.989-.814s-2.743-12.5 1.917-12.878 16.078-1.477 16.078-1.477 3.079.373 1.095 11.263z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M86.066 99.273l5.155.025c4.077-16.514 10.487-26.711 10.487-26.711 2.1-1.078 24.966-.5 24.966-.5 2.366.461 2.848 8 2.848 8s-2.055 1.7-.126 2.857c.864.516 3.729.663 7.039.558a56.051 56.051 0 0011.384-1.393c4.488-1.313.982-3.956.982-3.956s-.612-.839-.944-5.453a18.6 18.6 0 00-2.4-7.638 8.197 8.197 0 00-.306-.5 2.348 2.348 0 00-.805-.529c-5.872-2.576-34.862-.772-34.862-.772L98.649 66.47c-.3.113-.772.86-1.359 2.06-3.518 7.203-11.224 30.743-11.224 30.743z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M86.066 99.273l5.155.025c4.077-16.514 10.487-26.711 10.487-26.711 2.1-1.078 24.966-.5 24.966-.5 2.366.461 2.848 8 2.848 8s-2.055 1.7-.126 2.857c.864.516 3.729.663 7.039.558a56.051 56.051 0 0011.384-1.393c4.488-1.313.982-3.956.982-3.956s-.612-.839-.944-5.453a18.6 18.6 0 00-2.4-7.638 8.197 8.197 0 00-.306-.5 2.348 2.348 0 00-.805-.529c-5.872-2.576-34.862-.772-34.862-.772L98.649 66.47c-.3.113-.772.86-1.359 2.06-3.518 7.203-11.224 30.743-11.224 30.743z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M97.299 68.527c9.979-3.662 37.244-1.1 37.244-1.1 2.936-2.429 8.389-2.487 10.885-2.37a8.197 8.197 0 00-.306-.5 2.349 2.349 0 00-.805-.529c-5.872-2.576-34.862-.772-34.862-.772L98.65 66.469a5.291 5.291 0 00-1.351 2.058z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M132.92 68.439c.587 2.169 3 10.86 3 10.86a36.87 36.87 0 01.482 4.195 56.051 56.051 0 0011.384-1.393c4.488-1.313.982-3.956.982-3.956s-.612-.839-.944-5.453a18.52 18.52 0 00-2.706-8.138 2.349 2.349 0 00-.805-.529c-3.884.844-11.837 2.769-11.393 4.414z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__h",
  d: "M132.92 68.439c.587 2.169 3 10.86 3 10.86a36.87 36.87 0 01.482 4.195 56.051 56.051 0 0011.384-1.393c4.488-1.313.982-3.956.982-3.956s-.612-.839-.944-5.453a18.52 18.52 0 00-2.706-8.138 2.349 2.349 0 00-.805-.529c-3.884.844-11.837 2.769-11.393 4.414z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M72.316 10.615l12.8 42.068 53.385-7.722-7.051-25.285s-1.091-5.772-3.855-6.242c.001 0-42.683-8.23-55.279-2.819zm5.94 6.594c-1.724-5.68 23.633-2.848 23.633-2.848a60.947 60.947 0 0111.355.487c1.4.172 2.76.365 4.035.566 2.844.445 5.256.923 6.711 1.225.919.189 1.447.31 1.447.31 5.034 1.678 7.517 22.626 7.517 22.626.378 2.2-2.227 1.678-2.227 1.678h-.2l-2.374.046-7.064.138-34.522.7c-2.034-.247-2.3-2.659-2.3-2.659-1.066-1.733-6.011-22.269-6.011-22.269z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M130.529 41.261h.168s2.6.52 2.227-1.678c0 0-2.479-20.973-7.517-22.626 0 0-.529-.122-1.447-.31 1.791 3.616 7.466 16.028 6.569 24.614z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M130.529 41.261h.168s2.6.52 2.227-1.678c0 0-2.479-20.973-7.517-22.626 0 0-.529-.122-1.447-.31 1.791 3.616 7.466 16.028 6.569 24.614zM124.888 92.738a3.356 3.356 0 003.117 1.825l1.065-.025 10.067-.243 3.624-.088 3.356-.214 44.308-6.334-.252-4.358-5.113.633-2.1.26-31.271 3.872-4.115.512-2 .247-8.431-.222-9.136-.239a3.422 3.422 0 00-1.351.235 3.28 3.28 0 00-1.8 1.648 2.764 2.764 0 00.032 2.491z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M124.879 93.159a3.356 3.356 0 003.117 1.825l14.748-.357 3.356-.214 47.252-6.753 3.712-.533 2.026-.289c3.985-.763 2.878-4.757 2.878-4.757-.243-1.816-7.043-3.62-9.274-3.591-1.5 0-1.753 2.324-1.753 3.838a12.757 12.757 0 00.055 1.288l-2.211.273-43.223 5.37-17.55-.474a3.377 3.377 0 00-3.15 1.879 2.773 2.773 0 00.017 2.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M195.843 81.06a8.093 8.093 0 01-4.857 2.555 5.264 5.264 0 014.857-2.555zM196.209 87.549s6.2-.021 6.141 3.322-3.976 3.83-3.976 3.83l-55.6 9.614h-15.76s-5.424-4.5.327-6.338l15.885.717 53.007-8.687s-1.358-1.925-.024-2.458z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M127.005 104.715h15.755l49.429-8.532 3.62-.629 2.542-.419s3.914-.487 3.977-3.83c.046-2.4-3.138-3.066-4.941-3.251a11.567 11.567 0 00-1.2-.071c-1.334.529.025 2.437.025 2.437l-1.929.319-51.078 8.389-15.881-.717c-5.738 1.81-.319 6.304-.319 6.304z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M191.59 84.742l-3.247-1.527-1.678-.1-.126 14.081 5.176-.948 2.19-1.355 1.154-5.835a15.8 15.8 0 00-.575-2.659c-.205-.214-2.894-1.657-2.894-1.657z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M191.59 84.742l-3.247-1.527-1.678-.1-.126 14.081 5.176-.948 2.19-1.355 1.154-5.835a15.8 15.8 0 00-.575-2.659c-.205-.214-2.894-1.657-2.894-1.657z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M192.19 96.186l-.063.071 3.637-.629.046-.071c1.967-3.041 2.177-5.541 1.577-7.517a11.553 11.553 0 00-1.2-.071c-1.334.529.025 2.437.025 2.437l-1.93.319a8.692 8.692 0 01-2.092 5.461zM187.089 83.123c.608.247 1.17.5 1.678.763a11.077 11.077 0 014.568 3.775l3.712-.533a11.37 11.37 0 00-5.348-4.962l-.776.164z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M191.293 82.159s10.1 4.232 4.069 13.461l-3.641.629s7.336-8.087-5.034-13.133zM166.956 86.228l-3.763-.21.34 15.134 6.086-1 2.6-1.208 1.242-2.976.893-2.978-1.967-2.756-2.273-1.577z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M166.956 86.228l-3.763-.21.34 15.134 6.086-1 2.6-1.208 1.242-2.976.893-2.978-1.967-2.756-2.273-1.577z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__d",
  cx: 3.066,
  cy: 1.812,
  rx: 3.066,
  ry: 1.812,
  transform: "rotate(-88.92 132.13 -35.711)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__g",
  d: "M184.426 98.53a.986.986 0 01.47 1.384 7.054 7.054 0 00-.9 2.009c.071.445-.914.059-1.044-.046s-1.934-.038-2.013-1.258a2.123 2.123 0 011-1.862l-.369-2.7 2.487-.164-.071 2.458z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M184.426 98.53a.986.986 0 01.47 1.384 7.054 7.054 0 00-.9 2.009c.071.445-.914.059-1.044-.046s-1.934-.038-2.013-1.258a2.123 2.123 0 011-1.862l-.369-2.7 2.487-.164-.071 2.458z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M183.75 98.484s-.889 2.861-.529 2.97.529-2.97.529-2.97zM182.823 97.771s-.893 2.857-.529 2.97.529-2.97.529-2.97z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__g",
  d: "M172.966 88.92l1.233 8.67s1.728-.206 2.685-.39a1.947 1.947 0 00.6-.176c.046-.046.151-.042.285 0 .461.1 1.279.5 1.447.185a.208.208 0 01.046-.067c.168-.172.482-.038.789 0a.663.663 0 00.487-.055c.26-.168.776.117 1.2.218.268.063.5.055.608-.185a.579.579 0 01.419-.289c.419-.092.961 0 1.288-.076.126-.021.218-.067.247-.155.067-.189.419-.273.814-.336.47-.084.969-.138 1.011-.327 0-.063.059-.088.13-.088a3.9 3.9 0 01.759.2c.21.055.382.063.419-.088s.3-.143.57-.067.461.147.65.193.289.05.31-.029c.076-.277.969.369 1.187-.185s3.15-4.195-.453-9.073c0 0-1 .05-1.766.176a2.727 2.727 0 00-.742.193 4.433 4.433 0 01-1.346.13 1.679 1.679 0 00-.751.164.47.47 0 00-.214.218c-.122.264-.39.31-.684.289-.394-.029-.839-.189-.994-.113-.3.117-1.388-.025-1.577.155-.08.113-.508 0-.944-.084a1.066 1.066 0 00-.868.122.952.952 0 01-.684.185 3.987 3.987 0 00-.885.021.331.331 0 00-.18.109c-.18.214-.6.176-.982.189a1 1 0 00-.558.13.469.469 0 01-.2.08 5.968 5.968 0 01-1.678-.117z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M188.046 95.892c.218.059.461.147.65.193a6.856 6.856 0 00-.721-9.111 2.727 2.727 0 00-.742.193c2.78 3.347 1.383 7.408.813 8.725z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M186.279 95.846a3.9 3.9 0 01.759.2 6.871 6.871 0 00-1.162-8.746 1.677 1.677 0 00-.751.164c2.656 3.017 1.779 6.687 1.154 8.382z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M184.078 96.752c.126-.021.218-.067.247-.155.067-.189.419-.273.814-.336a6.789 6.789 0 00-.91-8.289c-.394-.029-.839-.189-.994-.113 2.919 3.427 1.405 7.651.843 8.893z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M181.754 97.302c.268.063.5.055.608-.185a.579.579 0 01.419-.289 6.893 6.893 0 00-1.145-8.809c-.08.113-.508 0-.944-.084 3.449 3.641 1.549 8.33 1.062 9.367z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M179.275 97.126c.168-.172.482-.038.789 0a6.867 6.867 0 00-.931-8.876 3.987 3.987 0 00-.885.021c2.952 3.314 1.631 7.424 1.027 8.855z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M176.884 97.201a1.946 1.946 0 00.6-.176c.046-.046.151-.042.285 0a6.785 6.785 0 00-.692-8.431 1 1 0 00-.558.13.469.469 0 01-.2.08c2.448 3.262 1.115 7.13.565 8.397z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 16.728,
  cy: 11.363,
  rx: 16.728,
  ry: 11.363,
  transform: "rotate(-88.92 109.29 9.71)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__e",
  cx: 13.557,
  cy: 8.259,
  rx: 13.557,
  ry: 8.259,
  transform: "rotate(-88.92 109.603 6.472)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__f",
  cx: 13.557,
  cy: 8.259,
  rx: 13.557,
  ry: 8.259,
  transform: "rotate(-88.92 109.393 6.258)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 1.674,
  cy: 0.977,
  rx: 1.674,
  ry: 0.977,
  transform: "rotate(-88.92 101.852 -7.32)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 1.674,
  cy: 0.977,
  rx: 1.674,
  ry: 0.977,
  transform: "rotate(-88.92 107.18 2.09)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 1.674,
  cy: 0.977,
  rx: 1.674,
  ry: 0.977,
  transform: "rotate(-88.92 109.057 -6.722)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 1.674,
  cy: 0.977,
  rx: 1.674,
  ry: 0.977,
  transform: "rotate(-88.92 112.48 -.325)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M26.649 69.776s-8.565 21.577-8.171 22.957c0 0-3.49 2.022-4.316 1.485s.088-10.143.088-10.143l1.728-8.435 1.871-4.987z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__j",
  d: "M26.649 69.776s-8.565 21.577-8.171 22.957c0 0-3.49 2.022-4.316 1.485s.088-10.143.088-10.143l1.728-8.435 1.871-4.987z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 1.674,
  cy: 0.977,
  rx: 1.674,
  ry: 0.977,
  transform: "rotate(-88.92 101.937 -1.831)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 3.972,
  cy: 2.857,
  rx: 3.972,
  ry: 2.857,
  transform: "rotate(-88.92 106.852 -.31)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__g",
  d: "M17.006 98.665c-.239 12.584 3.729 24.123 15.357 23.07 14.639-.038 15.977-9.9 16.212-22.492s-6.653-22.085-15.369-22.232-15.961 9.066-16.2 21.654z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M16.913 98.685c.185-9.744 4.568-17.479 10.583-20.4 7.626 1.6 13.343 10.512 13.125 22-.193 10.315-1.128 18.8-9.518 21.548-10.725.183-14.416-10.996-14.19-23.148z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M10.94 93.216s2.055 1.816 3.23.583c0 0 3.251-22.525 6.8-22.563l12.236.126s1.451.654 2.026 3.385l7.483 22.651 43.347 1.456 3.44-6.871-35.86-.575c-.18-.7-5.763-22.2-9.74-24.941a1.717 1.717 0 00-.419-.222s-14.912-2.269-19.849-1c0 0-5.147 1.053-6.43 2.6-.172.172-2.152 2.324-2.873 8.616z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M10.932 93.636s2.055 1.816 3.23.583c0 0 3.251-22.525 6.8-22.563l12.236.126s1.451.654 2.026 3.385l7.483 22.651 43.356 1.456 3.44-6.875-35.856-.57c-.185-.7-5.768-22.2-9.744-24.941a1.715 1.715 0 00-.419-.222s-14.912-2.269-19.849-1c0 0-5.143 1.053-6.43 2.6-.172.172-2.152 2.32-2.873 8.612z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M10.932 93.636s2.055 1.816 3.23.583c0 0 3.251-22.525 6.8-22.563l12.236.126s1.451.654 2.026 3.385l7.483 22.651 43.356 1.456 3.44-6.875-35.856-.57c-.185-.7-5.768-22.2-9.744-24.941a1.715 1.715 0 00-.419-.222s-14.912-2.269-19.849-1c0 0-5.143 1.053-6.43 2.6-.172.172-2.152 2.32-2.873 8.612z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M37.95 69.466c1.007 2.005 9.534 26.636 9.534 26.636l6.149-4.274c-.185-.7-5.776-22.232-9.753-24.945-2.629.381-6.613 1.22-5.93 2.583z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M49.867 58.501l4.614 16.191 25.625-.247-.252 2.4s-20.134 2.55-28.624-1.586l-4.32-14.79-40.428-.554 7.739-1.678z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__h",
  d: "M49.867 58.501l4.614 16.191 25.625-.247-.252 2.4s-20.134 2.55-28.624-1.586l-4.32-14.79-40.428-.554 7.739-1.678z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M169.463 86.135s13.6 7.16 3.3 13.448l-2.727.579s10.1-6.992-6.426-14.136z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M169.049 86.126s13.6 7.16 3.3 13.448l-2.731.587s10.1-6.992-6.426-14.136z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 13.07,
  cy: 7.634,
  rx: 13.07,
  ry: 7.634,
  transform: "rotate(-88.92 67.257 47.19)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__e",
  cx: 10.591,
  cy: 5.549,
  rx: 10.591,
  ry: 5.549,
  transform: "rotate(-88.92 67.354 44.896)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__f",
  cx: 10.591,
  cy: 5.549,
  rx: 10.591,
  ry: 5.549,
  transform: "rotate(-88.92 67.144 44.683)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 1.309,
  cy: 0.654,
  rx: 1.309,
  ry: 0.654,
  transform: "rotate(-88.92 60.933 34.388)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 1.309,
  cy: 0.654,
  rx: 1.309,
  ry: 0.654,
  transform: "rotate(-88.92 65.313 41.527)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 1.309,
  cy: 0.654,
  rx: 1.309,
  ry: 0.654,
  transform: "rotate(-88.92 66.193 35.216)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 1.309,
  cy: 0.654,
  rx: 1.309,
  ry: 0.654,
  transform: "rotate(-88.92 69.027 40.063)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 1.309,
  cy: 0.654,
  rx: 1.309,
  ry: 0.654,
  transform: "rotate(-88.92 61.295 38.388)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__g",
  cx: 3.104,
  cy: 1.921,
  rx: 3.104,
  ry: 1.921,
  transform: "rotate(-88.92 64.942 39.765)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M138.6 44.596s-23.221.419-53.486 8.087z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M28.642 1.878s1.258.227.57 1.879a11.451 11.451 0 00-.805 2.517s-1.258.633-1.179-1.535a3.243 3.243 0 011.414-2.861z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__k",
  d: "M77.48 41.609l1.85 7.362 6.376-5.583"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__l",
  d: "M69.648 47.052l18.84 3.234-3.179 18.517-18.84-3.234z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__g",
  d: "M75.114 66.157l.352-2.064a6.036 6.036 0 01-2.974-1.435l.726-1.288a6.434 6.434 0 003.029 1.426c1.451.247 2.576-.419 2.777-1.586s-.487-1.959-1.9-2.831c-1.942-1.174-2.836-2.3-2.517-4.077a3.3 3.3 0 013.532-2.781l.357-2.064 1.032.176-.34 1.984a5.545 5.545 0 012.538 1.17l-.742 1.258a4.5 4.5 0 00-2.341-1.116c-1.577-.273-2.1.608-2.236 1.426-.185 1.061.247 1.678 1.9 2.727 1.959 1.216 3.075 2.517 2.76 4.325a3.642 3.642 0 01-3.826 2.936l-.365 2.127z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M74.791 133.257a.629.629 0 10-.629-.629.629.629 0 00.629.629z"
})), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__a",
  cx: 7.836,
  cy: 1.326,
  rx: 7.836,
  ry: 1.326,
  transform: "translate(270.65 188.106)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__m",
  d: "M273.221 183.279s4.471-.138 5.818-1.095 6.875-2.1 7.206-.566 6.711 7.647 1.678 7.689-11.724-.784-13.07-1.607-1.632-4.421-1.632-4.421z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__n",
  d: "M288.007 188.769c-5.034.042-11.745-.784-13.066-1.6-1.023-.625-1.43-2.861-1.569-3.893h-.151s.285 3.6 1.628 4.421 8.024 1.648 13.07 1.607c1.456 0 1.959-.529 1.93-1.3-.202.467-.76.757-1.842.765z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__a",
  cx: 6.028,
  cy: 1.019,
  rx: 6.028,
  ry: 1.019,
  transform: "translate(317.898 172.981)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__m",
  d: "M319.874 169.265s3.44-.1 4.476-.839 5.289-1.619 5.549-.419 5.168 5.872 1.284 5.919-9.023-.6-10.067-1.233-1.242-3.428-1.242-3.428z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__n",
  d: "M331.249 173.49c-3.88.029-9.018-.6-10.067-1.233-.784-.482-1.1-2.2-1.2-3h-.117s.218 2.777 1.258 3.406 6.17 1.258 10.067 1.233c1.12 0 1.506-.419 1.485-1-.164.366-.591.588-1.426.594z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__a",
  cx: 14.392,
  cy: 2.433,
  rx: 14.392,
  ry: 2.433,
  transform: "translate(282.181 235.996)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__m",
  d: "M286.912 227.125s8.209-.256 10.68-2.018 12.63-3.863 13.242-1.036 12.336 14.052 3.07 14.123-21.535-1.443-24.006-2.936-2.986-8.133-2.986-8.133z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__n",
  d: "M314.064 237.213c-9.266.076-21.535-1.443-24-2.936-1.883-1.145-2.63-5.256-2.882-7.131h-.273s.52 6.619 2.987 8.125 14.736 3.02 24.006 2.936c2.676-.021 3.6-.973 3.549-2.383-.375.84-1.395 1.372-3.387 1.389z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M448.528 152.792a37.471 37.471 0 01-74.786 3.217c-.055-.608-.1-1.216-.113-1.837v-.029c-.021-.449-.029-.9-.029-1.351a37.471 37.471 0 0174.719-4.107 36.93 36.93 0 01.209 4.107z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__n",
  d: "M448.528 152.792a37.471 37.471 0 01-74.786 3.217c-.055-.608-.1-1.216-.113-1.837v-.029c-.021-.449-.029-.9-.029-1.351a37.471 37.471 0 0174.719-4.107 36.93 36.93 0 01.209 4.107z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "undraw_vehicle_sale_svg__d",
  cx: 20.44,
  cy: 20.44,
  r: 20.44,
  transform: "translate(390.612 132.347)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "undraw_vehicle_sale_svg__c",
  cx: 12.265,
  cy: 12.265,
  r: 12.265,
  transform: "translate(398.787 140.523)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M248.481 152.791a37.471 37.471 0 01-74.8 3.217c-.055-.608-.1-1.216-.113-1.837v-.029c0-.449-.029-.9-.029-1.351a37.471 37.471 0 0174.719-4.107 37.939 37.939 0 01.223 4.107z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__n",
  d: "M248.481 152.791a37.471 37.471 0 01-74.8 3.217c-.055-.608-.1-1.216-.113-1.837v-.029c0-.449-.029-.9-.029-1.351a37.471 37.471 0 0174.719-4.107 37.939 37.939 0 01.223 4.107z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "undraw_vehicle_sale_svg__d",
  cx: 20.44,
  cy: 20.44,
  r: 20.44,
  transform: "translate(190.566 132.347)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "undraw_vehicle_sale_svg__c",
  cx: 12.265,
  cy: 12.265,
  r: 12.265,
  transform: "translate(198.741 140.523)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.213 145.766l-12.5-.541-11.418-21.2-40.227-3.263-19.567 25.549 1.086 7.068-2.718 6.523-127.747 1.086v-3.263h-1.086l-1.07-4.891h9.786l-7.068-7.609-25-21.2s-42.945 1.086-43.49 0 2.437-12.232 2.437-12.232l18.482-5.453 63.058-4.9c13.842-22.013 26.363-32.345 26.363-32.345h162l7.609 39.14v.092z",
  fill: "#444053"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__p",
  d: "M369.966 148.484s16.309-30.44 28.813-30.44h30.441s7.613 0 10.872 5.982l12.508 24.459h-9.786s-8.154-22.831-17.4-23.372-25 0-25 0-5.453 0-8.7 6.523-14.283 20.734-14.283 20.734-11.802 3.728-7.465-3.886z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__p",
  d: "M467.281 143.593h-20.448l-.21 16.309 20.658-4.891zM171.56 133.807s1.086-8.154 8.7-11.414l50.025-2.718s8.154.541 12.5 10.872l14.119 21.191v3.259H241.14s-7.609-28.809-29.362-27.722h-26.086s-5.977 0-8.15 9.786zM288.98 72.381h166.883a5.982 5.982 0 00-5.977-5.982H294.957a5.981 5.981 0 00-5.977 5.982z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__q",
  d: "M324.744 104.453h-46.183a3.121 3.121 0 01-2.852-4.392l7.307-16.439a14.35 14.35 0 0113.125-8.523h28.058a3.93 3.93 0 013.93 3.93v22.047a3.377 3.377 0 01-3.385 3.377z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "undraw_vehicle_sale_svg__q",
  width: 45.117,
  height: 29.354,
  rx: 5.54,
  transform: "translate(340.079 75.099)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__p",
  d: "M459.127 108.258v.092l-70.126.994-1.824-40.222h64.341z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "undraw_vehicle_sale_svg__q",
  width: 51.644,
  height: 29.354,
  rx: 5.54,
  transform: "translate(394.983 75.099)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "undraw_vehicle_sale_svg__p",
  width: 17.395,
  height: 3.263,
  rx: 1.632,
  transform: "translate(313.984 114.78)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "undraw_vehicle_sale_svg__p",
  width: 17.395,
  height: 3.263,
  rx: 1.632,
  transform: "translate(363.997 114.78)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__l",
  d: "M399.223 71.852h20.13v19.782h-20.13z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__g",
  d: "M408.297 90.714v-2.206a6.36 6.36 0 01-3.356-.961l.524-1.464a6.754 6.754 0 003.393.94c1.552 0 2.6-.9 2.6-2.143s-.839-1.942-2.466-2.6c-2.232-.877-3.356-1.879-3.356-3.775a3.467 3.467 0 013.171-3.515v-2.206h1.107v2.118a5.793 5.793 0 012.84.763l-.545 1.443a4.748 4.748 0 00-2.63-.742c-1.678 0-2.064 1-2.064 1.875 0 1.137.558 1.707 2.458 2.492 2.248.919 3.633 2.051 3.633 4a3.787 3.787 0 01-3.448 3.712v2.269z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.457 175.372c-2.6 2.827-4.509 3.939-4.421.956.273-9.018-15.549-49.8-15.549-49.8l4.685-.352c10.205 17.641 14.014 35.764 15.285 49.196z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M177.819 195.048a22.546 22.546 0 01-45.013 1.938 19.34 19.34 0 01-.067-1.107v-.814a22.546 22.546 0 0144.958-2.471 21.9 21.9 0 01.122 2.454z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "undraw_vehicle_sale_svg__d",
  cx: 12.299,
  cy: 12.299,
  r: 12.299,
  transform: "translate(142.97 182.75)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "undraw_vehicle_sale_svg__c",
  cx: 7.378,
  cy: 7.378,
  r: 7.378,
  transform: "translate(147.89 187.67)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__c",
  d: "M96.056 152.23l-54.3 1.095v-8.016c.487-6.443 7.093-8.7 13.125-9.413a37.752 37.752 0 0114.027 1.053c11.518 3.05 18.876 3.641 22.475 3.7a3.448 3.448 0 013.335 2.8 123.442 123.442 0 01.84 5.14c.297 2.051.498 3.641.498 3.641z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__i",
  d: "M139.371 196.508H26.577a4.442 4.442 0 01-4.111-2.659c-.839-2.03.34-3.326 1.607-4.086a12.79 12.79 0 005.554-6.8c1.2-3.54 2.378-9.115 2.84-17.8.474-8.985 3.729-13.423 7.244-15.579a14.331 14.331 0 019.518-1.732l45.721.365a8.775 8.775 0 012.232 1.456c4.077 3.8-1.867 8.746-1.867 8.746-12.756 13.482-3.1 27.148-3.1 27.148h23.4a21.526 21.526 0 0012.257-3.75c3.163-2.185 4.388-4.3 4.862-5.579.361-.977.726-1.955 1.162-2.9 6.141-13.314-1.258-34.971-4.459-43.07-.793-2.013-1.326-3.188-1.326-3.188l7.374-.558 4.639-.352h.046c10.226 17.638 14.031 35.763 15.306 49.195q.18 1.9.3 3.67a16.405 16.405 0 01-16.409 17.466z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M95.557 148.589h-53.8v-2.24h53.46c.122.776.235 1.531.34 2.24z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M97.193 149.675H40.146a1.073 1.073 0 01-.419-.088 14.331 14.331 0 019.518-1.732l45.721.365a8.775 8.775 0 012.227 1.455z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "undraw_vehicle_sale_svg__d",
  width: 79.723,
  height: 2.236,
  rx: 1.118,
  transform: "translate(19.065 146.898)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M155.457 175.372c-2.6 2.827-4.509 3.939-4.421.956.273-9.018-15.549-49.8-15.549-49.8l4.685-.352c10.205 17.641 14.014 35.764 15.285 49.196z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M177.68 192.578c-2.689.646-6.019 1.3-10.126 1.9q-2.282.332-4.908.646c-4.195.495-9.035.931-14.631 1.258q-2.378.143-4.941.26-4.794.218-10.268.336l-.067-1.107c5.1-2.06 13.117-7.55 14.409-21.85a22.554 22.554 0 0130.532 18.565z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__i",
  d: "M128.49 196.508s25.872-2.823 16.971-42.252c0 0 12.789 11.745 20.742 18.242s22.135 15.52 22.135 15.52-8.468 7.899-59.848 8.49z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__h",
  d: "M128.49 196.508s25.872-2.823 16.971-42.252c0 0 12.789 11.745 20.742 18.242s22.135 15.52 22.135 15.52-8.468 7.899-59.848 8.49z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "undraw_vehicle_sale_svg__c",
  cx: 22.546,
  cy: 22.546,
  r: 22.546,
  transform: "translate(36.795 172.502)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "undraw_vehicle_sale_svg__d",
  cx: 12.299,
  cy: 12.299,
  r: 12.299,
  transform: "translate(47.043 182.75)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "undraw_vehicle_sale_svg__c",
  cx: 7.378,
  cy: 7.378,
  r: 7.378,
  transform: "translate(51.963 187.67)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M84.623 188.278c0-14.56-11.565-26.367-25.826-26.367s-25.83 11.808-25.83 26.367c0 .617.025 1.225.063 1.829h51.531a27.23 27.23 0 00.062-1.829z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__i",
  d: "M83.666 187.813c0-14.023-11.137-25.39-24.87-25.39s-24.874 11.367-24.874 25.39a16.293 16.293 0 00.063 1.758h49.618c.042-.567.063-1.154.063-1.758z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__h",
  d: "M83.664 187.813c0 .419 0 .81-.029 1.212a3.368 3.368 0 01-.029.545H33.977c0-.18-.025-.361-.034-.545 0-.419-.029-.805-.029-1.212 0-14.023 11.137-25.39 24.874-25.39s24.876 11.38 24.876 25.39z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M83.637 189.038a3.37 3.37 0 01-.029.545H33.977c0-.18-.025-.361-.034-.545z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "undraw_vehicle_sale_svg__e",
  width: 66.82,
  height: 5.831,
  rx: 2.915,
  transform: "translate(23.041 190.132)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "undraw_vehicle_sale_svg__d",
  width: 66.82,
  height: 5.831,
  rx: 2.915,
  transform: "translate(23.041 189.583)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__e",
  cx: 3.272,
  cy: 8.242,
  rx: 3.272,
  ry: 8.242,
  transform: "rotate(-24.33 390.442 -258.644)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__d",
  cx: 3.272,
  cy: 8.242,
  rx: 3.272,
  ry: 8.242,
  transform: "rotate(-24.33 389.944 -259.406)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M140.101 126.177v4.283h-8.326a14.51 14.51 0 01-2.32-.185c-.793-2.013-1.325-3.188-1.325-3.188l7.362-.558z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__i",
  d: "M140.101 129.927h-8.326c-7.324 0-13.255-5.478-13.255-12.236v-1.128c0-6.758 5.931-12.236 13.255-12.236l8.335.755z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__i",
  d: "M126.371 111.555s4.987 2.664 2.118 7.173c0 0-3.519 5.776-9.056 5.227l-2.013-12.4s6.627-.621 8.951 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__e",
  d: "M124.455 111.312a5.3 5.3 0 014.052 2.139 4.388 4.388 0 010 5.277s-3.519 5.776-9.056 5.227l-2.013-12.4a61.866 61.866 0 017.018-.243zM139.832 105.07a6.711 6.711 0 016.711 6.711v11.456a6.711 6.711 0 01-6.711 6.711z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__d",
  d: "M140.1 105.07a6.711 6.711 0 016.711 6.711v11.456a6.711 6.711 0 01-6.711 6.711z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "undraw_vehicle_sale_svg__i",
  cx: 5.537,
  cy: 6.737,
  rx: 5.537,
  ry: 6.737,
  transform: "translate(111.304 111.265)"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__k",
  d: "M57.865 149.151l2.42 5.386 4.044-5.386"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__l",
  d: "M50.21 154.763h19.732v19.392H50.21z"
}), /*#__PURE__*/React.createElement("path", {
  className: "undraw_vehicle_sale_svg__g",
  d: "M59.106 173.249v-2.164a6.245 6.245 0 01-3.276-.94l.512-1.435a6.645 6.645 0 003.331.919c1.518 0 2.546-.877 2.546-2.1s-.839-1.9-2.42-2.546c-2.185-.86-3.289-1.841-3.289-3.708a3.4 3.4 0 013.112-3.444v-2.162h1.082v2.1a5.7 5.7 0 012.785.751l-.537 1.414a4.651 4.651 0 00-2.576-.73c-1.648 0-2.026.986-2.026 1.841 0 1.116.549 1.678 2.412 2.441 2.206.9 3.561 2.013 3.561 3.918a3.733 3.733 0 01-3.381 3.641v2.227z"
}));

function SvgUndrawVehicleSale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467.281,
    height: 248.98
  }, props), _ref, _ref2);
}

export default SvgUndrawVehicleSale;